import Hero from "../components/Hero";
import Navbar from "../components/Navbar";
import Process from "../components/Process";
import Aboutinfo from "../components/Aboutinfo";
import ClientReviews, { CTABanner } from "../components/ClientReviews";
import FAQ from "../components/FAQ";
import Footer from "../components/FooterCTA";
import Projects from "../components/Projects";
import Homeser from "../components/homeser";
import Container from "../components/Container";
import ContactCTA from "../components/ContactCTA";

function Home({ openForm }) {
  return (
    <>
      {/* Main container with consistent max-width and centering */}
      <div className="w-full bg-white">
        <Navbar openForm={openForm} />

        <Container>
          <div className="mt-5"></div>

          <Hero />
          <Process />
          <Aboutinfo />
          <Homeser />
          <Projects />
          <ClientReviews />
          <FAQ />
          <ContactCTA />
        </Container>
        <Footer />
      </div>
    </>
  );
}

export default Home;